import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/es/servicios/clinical-solutions/gestión-de-la-seguridad-clínica")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/gestión-de-la-seguridad-clínica"),
  component: ClinicalOffering,
});

